<template>
  <div>

      <Card>
        <Row :gutter="24">
            <Col span="3">
              <Button type="primary" @click="add">新增</Button>
            </Col>
            <Col span="3">
                <Input v-model="params.name" @on-change="getSoftwareAssetsAuthorize">
                    <span slot="prepend">申请人</span>
                </Input>
            </Col>
            <Col span="3">
                <Input v-model="params.company" @on-change="getSoftwareAssetsAuthorize">
                    <span slot="prepend">厂商</span>
                </Input>
            </Col>
            <Col span="3">
                <Input v-model="params.status" @on-change="getSoftwareAssetsAuthorize">
                    <span slot="prepend">状态</span>
                </Input>
            </Col>
            <Col span="3">
                <Button type="text" icon="md-refresh-circle" @click="getSoftwareAssetsAuthorize"></Button>
            </Col>
        </Row>
      </Card>

    <Table highlight-row ref="currentRowTable" :columns="authorizeColumns" :data="assetList"></Table>
    <Page :total="count" :current="params.page" show-sizer show-total :page-size="params.size" @on-change="currentHandle" @on-page-size-change="pageSizeHandle"></Page>

    <Drawer
      :title="formItem.id ? '编辑' : '新增'"
      v-model="drawerChange"
      width="672"
      :mask-closable="false"
      @on-close="drawerChange=false"
    >
      <i-form ref="formItem" :model="formItem" :label-width="80" :rules="ruleValidate">
        <form-item label="软件名称" prop="name">
          <i-input v-model="formItem.name" placeholder=""></i-input>
        </form-item>

        <form-item label="厂商" prop="company">
          <i-input v-model="formItem.company" placeholder=""></i-input>
        </form-item>

        <form-item label="开始时间" prop="start_at">
          <DatePicker v-model="formItem.start_at" format="yyyy年MM月dd日" type="date" placeholder="Select date" style="width: 100%"></DatePicker>
        </form-item>

        <form-item label="结束时间" prop="end_at">
          <DatePicker v-model="formItem.end_at" format="yyyy年MM月dd日" type="date" placeholder="Select date" style="width: 100%"></DatePicker>
        </form-item>

        <form-item label="数量" prop="price">
          <i-input v-model="formItem.count" placeholder=""></i-input>
        </form-item>

        <form-item label="价格" prop="price">
          <i-input v-model="formItem.price" placeholder=""></i-input>
        </form-item>

        <form-item label="总价" prop="total_price">
          <i-input v-model="formItem.total_price" placeholder=""></i-input>
        </form-item>

        <form-item label="币别" prop="currency">
          <Select v-model="formItem.currency" style="width:100%">
            <Option v-for="item in countryList" :value="item.name" :key="item.name">
              {{ item.name }}
            </Option>
          </Select>
        </form-item>

        <form-item label="采购日期" prop="purchase_at">
          <DatePicker v-model="formItem.purchase_at" format="yyyy年MM月dd日" type="date" placeholder="Select date" style="width: 100%"></DatePicker>
        </form-item>

        <form-item label="备注" prop="remark">
          <i-input v-model="formItem.remark" placeholder=""></i-input>
        </form-item>

        <form-item>
          <i-button type="primary" @click="handleSubmit('formItem')">提交</i-button>
          <i-button style="margin-left: 8px" @click="drawerChange=false">取消</i-button>
        </form-item>
      </i-form>
      <spin fix v-if="changeLoadingShow">
        <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
        <div>请求中....</div>
      </spin>
    </Drawer>

    <Modal
        v-model="logModal"
        title="日志"
        :mask-closable="false"
        :scrollable="true">

        <template>
          <Timeline>
              <TimelineItem :color="item.content.indexOf('新增') !== -1 ? 'green' : 'red'" v-for="(item, index) in logs" :key="index">
                <p class="time">{{ item.created_at}}</p>
                <p class="content">{{ item.content}}</p>
                <p class="content">{{ item.remark}}</p>
              </TimelineItem>
          </Timeline>
        </template>
    </Modal>

  </div>
</template>

<script>
import moment from 'moment'
import { getSoftwareAssetsAuthorize, addSoftwareAssetsAuthorize, updateSoftwareAssetsAuthorize, deleteSoftwareAssetsAuthorize, addSoftwareAssetsLog, getSoftwareAssetsLog } from '@/api/cmdb'
export default {
  name: 'softwareAuthorize',
  data () {
    return {
      formItem: {
        name: null,
        company: null,
        start_at: null,
        end_at: null,
        count: null,
        price: null,
        total_price: null,
        currency: 'CNY - 人民币',
        purchase_at: null,
        update_user: this.$store.state.user.userId,
        remark: null
      },
      formItemSource: {},
      logs: [],
      ruleValidate: {
        name: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ]
      },
      authorizeColumns: [
        {
          width: 60,
          align: 'center',
          key: 'id',
          ellipsis: true,
          tooltip: true
        },
        {
          title: '软件名称',
          key: 'name',
          ellipsis: true,
          tooltip: true,
          minWidth: 100,
          render: (h, params) => {
            return h('a', {
              props: {
                type: 'warning',
                size: 'small'
              },
              on: {
                click: () => {
                  this.logModal = true
                  getSoftwareAssetsLog({ software_assets_authorize_id: params.row.id, page: 1, size: 1000 }).then(rsp => {
                    const { results } = rsp.data
                    this.logs = results
                  })
                }
              }
            }, params.row.name)
          }
        },

        {
          title: '厂商',
          key: 'company',
          ellipsis: true,
          tooltip: true,
          align: 'center',
          minWidth: 100
        },

        {
          title: '授权开始时间',
          key: 'start_at',
          align: 'center',
          tooltip: true,
          minWidth: 150,
          render: (h, params) => {
            if (params.row.start_at) {
              return h('span', moment(params.row.start_at).format('yyyy年MM月DD日'))
            } else {
              return ''
            }
          }
        },

        {
          title: '授权结束时间',
          key: 'end_at',
          align: 'center',
          tooltip: true,
          minWidth: 150,
          render: (h, params) => {
            if (params.row.end_at) {
              return h('span', moment(params.row.end_at).format('yyyy年MM月DD日'))
            } else {
              return ''
            }
          }
        },

        {
          title: '数量',
          key: 'count',
          align: 'center',
          ellipsis: true,
          tooltip: true,
          minWidth: 80
        },

        {
          title: '价格',
          key: 'price',
          align: 'center',
          ellipsis: true,
          tooltip: true,
          minWidth: 100
        },

        {
          title: '总价',
          key: 'total_price',
          align: 'center',
          ellipsis: true,
          tooltip: true,
          minWidth: 100
        },

        {
          title: '币别',
          key: 'currency',
          align: 'center',
          ellipsis: true,
          tooltip: true,
          minWidth: 150
        },

        {
          title: '采购日期',
          key: 'end_at',
          align: 'center',
          tooltip: true,
          minWidth: 150,
          render: (h, params) => {
            if (params.row.purchase_at) {
              return h('span', moment(params.row.purchase_at).format('yyyy年MM月DD日'))
            } else {
              return ''
            }
          }
        },

        {
          title: '维护人',
          key: 'update_user_info',
          ellipsis: true,
          tooltip: true,
          minWidth: 120,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Tag', {
              }, params.row.update_user_info.name)
            ])
          }
        },

        {
          title: '申请状态',
          key: 'status',
          minWidth: 100,
          align: 'center',
          ellipsis: true,
          tooltip: true,
          render: (h, params) => {
            return h('div', [
              h('Tag', {
                props: {
                  color: params.row.status === '授权期内' ? '#7232dd' : 'red'
                }
              }, params.row.status)
            ])
          }
        },

        {
          title: '创建时间',
          key: 'created_at',
          align: 'center',
          tooltip: true,
          minWidth: 150,
          render: (h, params) => {
            if (params.row.created_at) {
              return h('span', moment(params.row.created_at).format('YYYY-MM-DD HH:mm:ss'))
            } else {
              return ''
            }
          }
        },

        {
          title: '修改时间',
          key: 'updated_at',
          align: 'center',
          tooltip: true,
          minWidth: 150,
          render: (h, params) => {
            if (params.row.updated_at) {
              return h('span', moment(params.row.updated_at).format('YYYY-MM-DD HH:mm:ss'))
            } else {
              return ''
            }
          }
        },

        {
          title: '备注',
          key: 'remark',
          ellipsis: true,
          tooltip: true
        },
        {
          title: '操作',
          align: 'center',
          fixed: 'right',
          width: 150,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.formItem = { ...params.row }
                    this.formItemSource = { ...params.row }
                    this.drawerChange = true
                  }
                }
              }, '编辑'),
              h('Poptip', {
                props: {
                  confirm: true,
                  transfer: true,
                  placement: 'bottom',
                  title: '你确定要删除吗?'
                },
                style: {
                  display: this.$store.state.user.superuser ? 'inline-block' : 'none'
                },
                on: {
                  'on-ok': () => {
                    deleteSoftwareAssetsAuthorize({ id: params.row.id }).then(_ => {
                      this.getSoftwareAssetsAuthorize()
                    })
                  }
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  }
                }, '删除')
              ])
            ])
          }
        }

      ],
      params: { page: 1, size: 10 },
      assetList: [],
      count: 0,
      drawerChange: false,
      changeLoadingShow: false,
      logModal: false,
      countryList: [
        { id: '1', key: 'CNY', name: 'CNY - 人民币' },
        { id: '2', key: 'USD', name: 'USD - 美元' },
        { id: '3', key: 'EUR', name: 'EUR - 欧元' },
        { id: '4', key: 'GBP', name: 'GBP - 英镑' },
        { id: '5', key: 'JPY', name: 'JPY - 日元' },
        { id: '6', key: 'HKD', name: 'HKD - 港币' },
        { id: '7', key: 'AUD', name: 'AUD - 澳元' },
        { id: '8', key: 'CAD', name: 'CAD - 加元' }
      ]
    }
  },
  mounted () {
    this.getSoftwareAssetsAuthorize()
  },
  methods: {

    add () {
      this.drawerChange = true
      this.formItem = {
        name: null,
        company: null,
        start_at: null,
        end_at: null,
        count: null,
        price: null,
        total_price: null,
        currency: 'CNY - 人民币',
        purchase_at: null,
        update_user: this.$store.state.user.userId,
        remark: null
      }
    },

    getSoftwareAssetsAuthorize () {
      getSoftwareAssetsAuthorize(this.params).then(rsp => {
        const { results, count } = rsp.data
        this.assetList = results
        this.count = count
      })
    },

    currentHandle (page) {
      this.params.page = page
      this.getSoftwareAssetsAuthorize()
    },

    pageSizeHandle (size) {
      this.params.size = size
      this.getSoftwareAssetsAuthorize()
    },

    handleSubmit (name) {
      let that = this.formItem
      let remark = {}
      this.$refs[name].validate((valid) => {
        if (valid) {
          Object.keys(this.formItem).forEach(_key => {
            if (this.formItem[_key] !== this.formItemSource[_key]) {
              remark[_key] = `${this.formItemSource[_key]} -> ${this.formItem[_key]}`
            }
          })
          this.changeLoadingShow = true
          if (that.id) {
            if (Object.keys(remark).length !== 0) {
              updateSoftwareAssetsAuthorize(that).then(rsp => {
                const { data } = rsp
                this.getSoftwareAssetsAuthorize()
                addSoftwareAssetsLog({ log_type: '授权软件', content: '修改', operator_id: this.$store.state.user.userId, software_assets_authorize: data.id, remark: JSON.stringify(remark) })
                this.changeLoadingShow = false
                this.drawerChange = false
                this.$Notice.success({ title: '修改成功' })
              })
            } else {
              this.changeLoadingShow = false
              this.$Notice.error({ title: '无数据变化！' })
            }
          } else {
            addSoftwareAssetsAuthorize(that).then(rsp => {
              const { data } = rsp
              this.getSoftwareAssetsAuthorize()
              addSoftwareAssetsLog({ log_type: '授权软件', content: '新增', operator_id: this.$store.state.user.userId, software_assets_authorize: data.id, remark: JSON.stringify(this.formItem) })
              this.changeLoadingShow = false
              this.drawerChange = false
              this.$Notice.success({ title: '添加成功' })
            })
          }
        } else {
          this.changeLoadingShow = false
          this.$Notice.error({ title: '请检查输入框！' })
        }
      })
    }

  }
}
</script>
